import { useCallback } from 'react'

import { SupportedEventData } from '@appTypes/GoogleTagManager.interface'

const useGoogleTagManager = () => {
    const dataLayer =
        typeof window !== 'undefined' && typeof window.dataLayer !== 'undefined'
            ? window.dataLayer
            : []

    const send = useCallback((eventData: SupportedEventData) => {
        if (dataLayer != null) {
            dataLayer.push(eventData)
        } else {
            console.log('[GTM Event]', eventData)
        }
    }, [])

    return send
}

export default useGoogleTagManager
